const typography = {
  fontFamily: {
    primary: "'Jost', sans-serif",
    secondary: "'Jost', sans-serif",
    inter: "'Inter', sans-serif",
  },

  labName: {
    fontFamily: "'Jost', sans-serif",
    fontSize: '22.2px',
    fontWeight: 400,
    fontStyle: 'normal',
    lineHeight: '100%',
    letterSpacing: '5%',
    textTransform: 'uppercase',
  },

  largeNumbers: {
    fontSize: '53px',
    lineHeight: '100%',
    fontWeight: 400,
    letterSpacing: '-1.5%',
    textAlign: 'center',
    fontFamily: "'Jost', sans-serif",
  },

  largeNumbersMobile: {
    fontSize: '45px',
    lineHeight: '100%',
    fontWeight: 400,
    letterSpacing: '-1.5%',
    textAlign: 'center',
    fontFamily: "'Jost', sans-serif",
  },

  heading: {
    mobile: {
      fontSize: '16px',
      lineHeight: '110%',
      fontWeight: 800,
      letterSpacing: '-3%',
      verticalAlign: 'middle',
      fontFamily: "'Inter', sans-serif",
    },
    xlarge: {
      fontSize: '54px',
      lineHeight: '125%',
      fontWeight: 700,
      fontFamily: "'Jost', sans-serif",
    },
    large: {
      fontSize: '48px',
      lineHeight: '58px',
      fontWeight: 500,
      fontFamily: "'Jost', sans-serif",
    },
    medium: {
      fontSize: '34px',
      lineHeight: '125%',
      fontWeight: 700,
      fontFamily: "'Jost', sans-serif",
    },
    small: {
      fontSize: '30px',
      lineHeight: '125%',
      fontWeight: 700,
      fontFamily: "'Jost', sans-serif",
    },
    xsmall: {
      fontSize: '24px',
      lineHeight: '125%',
      fontWeight: 700,
      fontFamily: "'Jost', sans-serif",
    },
  },

  eyebrow: {
    regular: {
      fontSize: '16px',
      lineHeight: '125%',
      fontWeight: 600,
      letterSpacing: '0.19em',
      textTransform: 'uppercase',
      fontFamily: "'Jost', sans-serif",
    },
    small: {
      fontSize: '14px',
      lineHeight: '125%',
      fontWeight: 600,
      letterSpacing: '0.19em',
      textTransform: 'uppercase',
      fontFamily: "'Jost', sans-serif",
    },
  },

  body: {
    xxlarge: {
      regular: {
        fontSize: '22px',
        lineHeight: '150%',
        fontWeight: 400,
        fontFamily: "'Jost', sans-serif",
      },
      medium: {
        fontSize: '22px',
        lineHeight: '150%',
        fontWeight: 500,
        fontFamily: "'Jost', sans-serif",
      },
      semibold: {
        fontSize: '22px',
        lineHeight: '150%',
        fontWeight: 600,
        letterSpacing: '0%',
        fontFamily: "'Jost', sans-serif",
      },
      bold: {
        fontSize: '22px',
        lineHeight: '150%',
        fontWeight: 700,
        fontFamily: "'Jost', sans-serif",
      },
    },

    xlarge: {
      regular: {
        fontSize: '20px',
        lineHeight: '150%',
        fontWeight: 400,
        fontFamily: "'Jost', sans-serif",
      },
      medium: {
        fontSize: '20px',
        lineHeight: '150%',
        fontWeight: 500,
        fontFamily: "'Jost', sans-serif",
      },
      semibold: {
        fontSize: '20px',
        lineHeight: '150%',
        fontWeight: 600,
        fontFamily: "'Jost', sans-serif",
      },
      bold: {
        fontSize: '20px',
        lineHeight: '150%',
        fontWeight: 700,
        fontFamily: "'Jost', sans-serif",
      },
    },

    large: {
      regular: {
        fontSize: '18px',
        lineHeight: '170%',
        fontWeight: 400,
        fontFamily: "'Jost', sans-serif",
      },
      medium: {
        fontSize: '18px',
        lineHeight: '170%',
        fontWeight: 500,
        fontFamily: "'Jost', sans-serif",
      },
      semibold: {
        fontSize: '18px',
        lineHeight: '170%',
        fontWeight: 600,
        letterSpacing: '0%',
        fontFamily: "'Jost', sans-serif",
      },
      bold: {
        fontSize: '18px',
        lineHeight: '170%',
        fontWeight: 700,
        fontFamily: "'Jost', sans-serif",
      },
    },

    medium: {
      regular: {
        fontSize: '16px',
        lineHeight: '170%',
        fontWeight: 400,
        fontFamily: "'Jost', sans-serif",
      },
      medium: {
        fontSize: '16px',
        lineHeight: '170%',
        fontWeight: 500,
        fontFamily: "'Jost', sans-serif",
      },
      bold: {
        fontSize: '16px',
        lineHeight: '170%',
        fontWeight: 700,
        fontFamily: "'Jost', sans-serif",
      },
    },

    small: {
      regular: {
        fontSize: '14px',
        lineHeight: '150%',
        fontWeight: 400,
        fontFamily: "'Jost', sans-serif",
      },
      medium: {
        fontSize: '14px',
        lineHeight: '150%',
        fontWeight: 500,
        fontFamily: "'Jost', sans-serif",
      },
      bold: {
        fontSize: '14px',
        lineHeight: '150%',
        fontWeight: 700,
        fontFamily: "'Jost', sans-serif",
      },
    },

    xsmall: {
      regular: {
        fontSize: '12px',
        lineHeight: '150%',
        fontWeight: 400,
        fontFamily: "'Jost', sans-serif",
      },
      medium: {
        fontSize: '12px',
        lineHeight: '150%',
        fontWeight: 500,
        fontFamily: "'Jost', sans-serif",
      },
      bold: {
        fontSize: '12px',
        lineHeight: '150%',
        fontWeight: 700,
        fontFamily: "'Jost', sans-serif",
      },
    },
  },
};

export default typography;
